import React from "react";
import platforms from "../data/platforms";

const seamlessPlatforms = [...platforms, ...platforms]; // For infinite loop effect

const AvailableOn = () => {
  return (
    <div className="bg-gray-50 py-10 overflow-hidden relative">
      <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
        We Are Available On
      </h2>

      <div className="carousel-track-container">
        <div className="carousel-track">
          {seamlessPlatforms.map((platform, index) => (
            <a
              key={index}
              href={platform.link}
              target="_blank"
              rel="noopener noreferrer"
              className="carousel-item"
            >
              <img
                src={platform.logo}
                alt={platform.name}
                className="h-12 object-contain"
              />
            </a>
          ))}
        </div>
      </div>

      <style jsx="true">{`
        .carousel-track-container {
          overflow: hidden;
          width: 100%;
        }

        .carousel-track {
          display: flex;
          width: fit-content;
          animation: scrollX 30s linear infinite;
        }

        .carousel-item {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 150px;
          padding: 0 1rem;
          transition: transform 0.3s;
        }

        .carousel-item:hover {
          transform: scale(1.05);
        }

        @keyframes scrollX {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        @media (max-width: 640px) {
          .carousel-item {
            min-width: 100px;
          }
        }
      `}</style>
    </div>
  );
};

export default AvailableOn;
